
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'EmptyPage',
})
export default class EmptyPage extends Vue {
  @Prop({ default: '' }) image!: string;
  /** material icon name; when set, renders a branded kx tile instead of the image */
  @Prop({ default: '' }) icon!: string;
  @Prop({ required: true }) title!: string;
  @Prop({ default: '' }) subTitle!: string;
  @Prop({ default: '70px' }) imageWidth!: string;
}
